import { createSlice } from '@reduxjs/toolkit';
import { HTTP_GETTYPE, STATUS_API } from 'src/app/constant/config';
import AxiosAdapter from './AxiosAdapter';

//api search man giam sat
export const getListVehicle = AxiosAdapter.GetHttp(
  'vehicleSlice/GetListVehicles',
  '/vehicles',
  HTTP_GETTYPE.ALL_PAGINATION
);

//ap get list xe view map
export const getListVehicleTracking = AxiosAdapter.GetHttp(
  'vehicleSlice/GetListVehiclesTracking',
  '/vehicles/tracking',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getListVehicleTrackingById = AxiosAdapter.HttpGetById(
  'vehicleSlice/GetListVehiclesTracking',
  '/vehicles/tracking/agency',
);

export const getListVehicleTrackingByUserId = AxiosAdapter.HttpGetById(
  'vehicleSlice/GetListVehiclesTracking',
  '/vehicles/tracking/endUser',
);

export const getListVehicleTrackingAdmin = AxiosAdapter.GetHttp(
  'vehicleSlice/GetListVehiclesTracking',
  '/vehicles/tracking/all',
  HTTP_GETTYPE.ALL
);

export const getDetailVehicle = AxiosAdapter.HttpGetById(
  'deviceSlice/getDetailVehicle',
  '/vehicles/detail'
)

export const getVehicleByOwnerId = AxiosAdapter.GetHttp(
  'vehicleSlice/GetVehicleByOwnerId',
  '/vehicles/users/',
  HTTP_GETTYPE.DETAIL
)

export const getVehicleLicensePlate = AxiosAdapter.GetHttp(
  'vehicleSlice/GetVehicleLicensePlate',
  '/vehicles/license_plate',
  HTTP_GETTYPE.DETAIL
)

export const getVehicleLicensePlateCamera = AxiosAdapter.GetHttp(
  'vehicleSlice/GetVehicleLicensePlateCamera',
  '/vehicles/license_plate/camera',
  HTTP_GETTYPE.DETAIL
)

export const vehicleSlice = createSlice({
  name: 'vehicleSlice',
  initialState: {
    listVehicle: [],
    listLicensePlate: [],
    listLicensePlateCamera: [],
    totalVehicle: 0,
    errorGetList: null,
    errGetListLicensePlate: null,
    errGetListLicensePlateCamera: null,
    statusGetListVehicle: null,
    centerMap: { lat: 20.983173, lng: 105.766006 },

    agencySelected: null,
    listVehicleTracking: [],
    statisticVehicleTracking: null, // so luong cac xe o moi loai dung do
    statisticVehicleStatus: null, // so luong cac xe o moi loai WEBSOCKET

    totalVehicleTracking: 0,
    errorListTracking: null,
    statusGetListTracking: null,
    errorGetVehicleByOwnerId: null,
    statusGetVehicleByOwnerId: null,
    statusGetListLicensePlate: null,
    statusGetListLicensePlateCamera: null,

    err: null,
    detailVehicle: null,
    statusGetDetail: null,
    userSelected: null,
    selectedLicensePlate: null,
    existLincesePlate: true,
    positionsVehicle: null,
    isLoading: false,
  },

  reducers: {
    
    setListVehicleTracking: (state, action) => {
      state.listVehicleTracking = action.payload;
    },
    setStatisticVehicleStatus: (state, action) => {
      state.statisticVehicleStatus = action.payload;
    },
    setUserSelected: (state, action) => {
      state.userSelected = action.payload;
    },

    setSelectedLicensePlate: (state, action) => {
      state.selectedLicensePlate = action.payload;
    },

    setCenterMap: (state, action) => {
      state.centerMap = action.payload;
    },

    setExistLincesePlate: (state, action) => {
      state.selectedLicensePlate = action.payload;
    },

    setGetListLoading: (state, action) => {
      state.statusGetListTracking = action.payload;
    },

    resetListVehicle: (state, action) => {
      state.listVehicle = [];
      state.totalVehicle = 0;
      state.statusGetListVehicle = null;
    },

    resetChange: state => {
      state.statusGetListVehicle = null;
      state.statusGetDetail = null;
      state.userSelected = null;
      state.selectedLicensePlate = null;
      state.isLoading = false;
    },
  },

  extraReducers: {
    // Get list vehicles 
    [getListVehicle.pending]: state => {
      state.statusGetListVehicle = STATUS_API.PENDING;
    },

    [getListVehicle.fulfilled]: (state, action) => {
      state.statusGetListVehicle = STATUS_API.SUCCESS;
      state.listVehicleTracking = action.payload.payload.data;
      state.totalVehicle = action.payload.payload.total;
    },

    [getListVehicle.rejected]: (state, action) => {
      state.statusGetListVehicle = STATUS_API.ERROR;
      state.errorGetList = action.payload?.message || action.error;
    },

    //Get list tracking
    [getListVehicleTracking.pending]: state => {
      state.isLoading = true;
      if (state.listVehicleTracking.length === 0 || state.statusGetListTracking === STATUS_API.LOADING) {
        state.listVehicleTracking = [];
      }
      state.totalVehicleTracking = 0;
    },
    [getListVehicleTracking.fulfilled]: (state, action) => {
      state.statusGetListTracking = STATUS_API.SUCCESS;
      state.listVehicleTracking = action.payload.payload.latest_periodics;
      state.statisticVehicleTracking = action.payload.payload.statistic;
      state.isLoading = false;
    },
    [getListVehicleTracking.rejected]: (state, action) => {
      state.statusGetListTracking = STATUS_API.ERROR;
      state.errorListTracking = action.payload?.message || action.error;
      state.isLoading = true;
    },
    //Get list tracking by id
    [getListVehicleTrackingById.pending]: state => { 
      state.isLoading = true;
      if (state.listVehicleTracking.length === 0 || state.statusGetListTracking === STATUS_API.LOADING) {
        state.listVehicleTracking = [];
      }
      state.totalVehicleTracking = 0;
    },
    [getListVehicleTrackingById.fulfilled]: (state, action) => {
      state.statusGetListTracking = STATUS_API.SUCCESS;
      state.listVehicleTracking = action.payload.payload.latest_periodics;
      state.statisticVehicleTracking = action.payload.payload.statistic;
      state.isLoading = false;
    },
    [getListVehicleTrackingById.rejected]: (state, action) => {
      state.statusGetListTracking = STATUS_API.ERROR;
      state.errorListTracking = action.payload?.message || action.error;
      state.isLoading = true;
    },
    
    //Get list license plate
    [getVehicleLicensePlate.pending]: state => {
      state.statusGetListLicensePlate = STATUS_API.PENDING;
    },
    [getVehicleLicensePlate.fulfilled]: (state, action) => {
      state.statusGetListLicensePlate = STATUS_API.SUCCESS;
      state.listLicensePlate = action.payload.payload.result.result;
    },
    [getVehicleLicensePlate.rejected]: (state, action) => {
      state.statusGetListLicensePlate = STATUS_API.ERROR;
      state.errGetListLicensePlate = action.payload?.message || action.error;
    },

    //Get list license plate camera
    [getVehicleLicensePlateCamera.pending]: state => {
      state.statusGetListLicensePlateCamera = STATUS_API.PENDING;
    },
    [getVehicleLicensePlateCamera.fulfilled]: (state, action) => {
      state.statusGetListLicensePlateCamera = STATUS_API.SUCCESS;
      state.listLicensePlateCamera = action.payload.payload.result.result;
    },
    [getVehicleLicensePlateCamera.rejected]: (state, action) => {
      state.statusGetListLicensePlateCamera = STATUS_API.ERROR;
      state.errGetListLicensePlateCamera = action.payload?.message || action.error;
    },

    //Get Detail vehicle
    [getDetailVehicle.pending]: state => {
      state.statusGetDetail = STATUS_API.PENDING;
      state.err = null;
      state.detailVehicle = null;
    },
    [getDetailVehicle.fulfilled]: (state, action) => {
      state.statusGetDetail = STATUS_API.SUCCESS;
      state.detailVehicle = action.payload.payload.vehicle;
    },
    [getDetailVehicle.rejected]: (state, action) => {
      state.statusGetDetail = STATUS_API.ERROR;
      state.errorGetList = action.payload?.message || action.error;
    },
    [getVehicleByOwnerId.pending]: state => {
      state.statusGetVehicleByOwnerId = STATUS_API.PENDING;
      state.errorGetVehicleByOwnerId = null;
      state.listVehicle = [];
    },
    [getVehicleByOwnerId.fulfilled]: (state, action) => {
      state.statusGetVehicleByOwnerId = STATUS_API.SUCCESS;
      state.errorGetVehicleByOwnerId = null;
      state.listVehicle = action.payload.payload.vehicles;
    },
    [getVehicleByOwnerId.rejected]: (state, action) => {
      state.statusGetVehicleByOwnerId = STATUS_API.ERROR;
      state.errorGetVehicleByOwnerId = action.payload?.message || action.error;
      state.listVehicle = [];
    }
  }
});
export const {
  resetChange,
  setCenterMap,
  setUserSelected,
  setSelectedLicensePlate,
  setExistLincesePlate,
  setGetListLoading,
  setListVehicleTracking,
  setStatisticVehicleStatus,
  resetListVehicle
} = vehicleSlice.actions;

export default vehicleSlice.reducer;
